import script from "./LeaderProjectShowcase.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectShowcase.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectShowcase.vue?vue&type=style&index=0&id=8cb6ea94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cb6ea94"]])

export default __exports__